import { useEffect, useState } from 'react'
import { useImmer } from 'use-immer'
import { Box, Button, Card, CardBody, CardHeader, Flex, FormControl, FormLabel, Heading, Input, VStack } from '@chakra-ui/react'
import { UiBreadcrumb } from 'components/common'
import { useAppContext } from 'hooks/useAppContext'
import { getCabinetPricingConfig, setCabinetPricingConfig } from 'api'

const BreadcrumbNav = [
  {
    label: 'Lightbox / ID Cabinet Pricing',
    isCurrentPage: true
  }
]

export const CabinetPricingForm = () => {
  const { createToast } = useAppContext()
  const [form, setForm] = useImmer({
    cabinetSingleBase: 0,
    cabinetSinglePerSqft: 0,
    cabinetDoubleBase: 0,
    cabinetDoublePerSqft: 0
  })
  const [isSaving, setIsSaving] = useState(false)

  useEffect(() => {
    const load = async () => {
      try {
        const response = await getCabinetPricingConfig()
        setForm(draft => {
          draft.cabinetSingleBase = response.cabinetSingleBase
          draft.cabinetSinglePerSqft = response.cabinetSinglePerSqft
          draft.cabinetDoubleBase = response.cabinetDoubleBase
          draft.cabinetDoublePerSqft = response.cabinetDoublePerSqft
        })
      } catch (err) {
        createToast('error', 'Error', err.response.data)
      }
    }
    load()
  }, [])

  const handleChange = (e) => {
    setForm(draft => {
      draft[e.target.name] = e.target.value
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    setIsSaving(true)
    try {
      const response = await setCabinetPricingConfig({
        cabinetSingleBase: form.cabinetSingleBase,
        cabinetSinglePerSqft: form.cabinetSinglePerSqft,
        cabinetDoubleBase: form.cabinetDoubleBase,
        cabinetDoublePerSqft: form.cabinetDoublePerSqft
      })
      setForm(draft => {
        draft.cabinetSingleBase = response.cabinetSingleBase
        draft.cabinetSinglePerSqft = response.cabinetSinglePerSqft
        draft.cabinetDoubleBase = response.cabinetDoubleBase
        draft.cabinetDoublePerSqft = response.cabinetDoublePerSqft
      })
      createToast('success', 'Successfully updated.')
      setIsSaving(false)
    } catch (err) {
      createToast('error', 'Error', err.response.data)
      setIsSaving(false)
    }
  }

  return (
    <>
      <UiBreadcrumb items={BreadcrumbNav} />
      <Box>
        <Flex justifyContent="space-between" alignItems="center" my={8}>
          <Heading size="lg">Lightbox / ID Cabinet Pricing</Heading>
        </Flex>
        <Card borderRadius={0}>
          <CardHeader bg="gray.500" p={4}>
            <Heading color="white" size="sm">Configuration</Heading>
          </CardHeader>
          <CardBody p={8}>
            <form onSubmit={handleSubmit}>
              <VStack gap={2} maxW="500px">
                <FormControl isRequired>
                  <FormLabel>Single Face Base Price</FormLabel>
                  <Input type="number" name="cabinetSingleBase" value={form.cabinetSingleBase} onChange={handleChange} />
                </FormControl>
                <FormControl isRequired>
                  <FormLabel>Single Face Price Per Sqft</FormLabel>
                  <Input type="number" name="cabinetSinglePerSqft" value={form.cabinetSinglePerSqft} onChange={handleChange} />
                </FormControl>
                <FormControl isRequired>
                  <FormLabel>Double Face Base Price</FormLabel>
                  <Input type="number" name="cabinetDoubleBase" value={form.cabinetDoubleBase} onChange={handleChange} />
                </FormControl>
                <FormControl isRequired>
                  <FormLabel>Double Face Price Per Sqft</FormLabel>
                  <Input type="number" name="cabinetDoublePerSqft" value={form.cabinetDoublePerSqft} onChange={handleChange} />
                </FormControl>
              </VStack>
              <Button type="submit" mt={8} colorScheme="blue" isLoading={isSaving}>Save</Button>
            </form>
          </CardBody>
        </Card>
      </Box>
    </>
  )
}
